import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import React from "react";
var __jsx = React.createElement;

/* eslint-disable max-lines */
import { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { useInlineToolbar } from 'components/common/RichTextEditor/hooks';
import { useCurrentSelectionEntityType } from 'components/common/RichTextEditor/hooks/useCurrentSelectionEntityType';
import { useCurrentSelectionStyleType } from 'components/common/RichTextEditor/hooks/useCurrentSelectionStyleType';
import { Blocks, InlineToolbarTab } from 'components/common/RichTextEditor/types';
import { AffiliationLinkTab, BoldTab, ExternalLinkTab, HighlightTab, InternalLinkTab, ItalicTab, ResetTab, SuperScriptTab, UnderlineTab } from 'components/common/RichTextEditor/types/inlineToolbarTabs/';
import { ExternalLinkInput } from 'components/content/ExternalLinkInput';
import { ButtonContainer, HorizontalSeparator, ToolbarContainer, VerticalSeparator } from './InlineToolbar.style';

var InlineToolbar = function InlineToolbar(_ref) {
  var _availableTabs;

  var editorRef = _ref.editorRef,
      editorState = _ref.editorState,
      setEditorState = _ref.setEditorState,
      handleHighlightToggle = _ref.handleHighlightToggle,
      handleInlineStyleToggle = _ref.handleInlineStyleToggle,
      handleResetStyleToggle = _ref.handleResetStyleToggle,
      addExternalLink = _ref.addExternalLink,
      addInternalLink = _ref.addInternalLink,
      addAffiliationLink = _ref.addAffiliationLink,
      enabledBlocks = _ref.enabledBlocks;
  var toolbarRef = useRef(null);

  var _useState = useState(false),
      keepOpen = _useState[0],
      setKeepOpen = _useState[1];

  var _useState2 = useState(false),
      isExternalLinkToolOpen = _useState2[0],
      setIsExternalLinkToolOpen = _useState2[1];

  var isToolbarOpen = useInlineToolbar(editorRef, toolbarRef, editorState.getSelection(), keepOpen);
  var contentState = editorState.getCurrentContent();
  var selectionState = editorState.getSelection();
  var firstSelectedBlock = contentState.getBlockForKey(selectionState.getStartKey());
  var handleExternalLinkToolToggle = useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
    setIsExternalLinkToolOpen(function (open) {
      return !open;
    });
    setKeepOpen(function (open) {
      return !open;
    });
  }, []);
  var handleInternalLinkToolToggle = useCallback(function (event) {
    event.preventDefault();
    addInternalLink({
      contentId: '',
      attributes: {
        rel: '',
        target: ''
      },
      editLink: true,
      firstPrintOpenModal: true,
      label: ''
    });
  }, [addInternalLink]);
  var handleAffiliationLinkToolToggle = useCallback(function (event) {
    event.preventDefault();
    addAffiliationLink({
      affiliationId: undefined,
      productName: '',
      editLink: true,
      firstPrintOpenModal: true
    });
  }, [addAffiliationLink]);
  var selectionType = useCurrentSelectionStyleType(editorState);
  var currentEntityType = useCurrentSelectionEntityType(editorState);
  var currentBlock = Blocks[selectionType];
  var availableTabs = (_availableTabs = {}, _defineProperty(_availableTabs, InlineToolbarTab.BOLD, BoldTab), _defineProperty(_availableTabs, InlineToolbarTab.ITALIC, ItalicTab), _defineProperty(_availableTabs, InlineToolbarTab.UNDERLINE, UnderlineTab), _defineProperty(_availableTabs, InlineToolbarTab.SUPERSCRIPT, SuperScriptTab), _defineProperty(_availableTabs, InlineToolbarTab.INTERNAL_LINK, InternalLinkTab), _defineProperty(_availableTabs, InlineToolbarTab.EXTERNAL_LINK, ExternalLinkTab), _defineProperty(_availableTabs, InlineToolbarTab.AFFILIATION_LINK, AffiliationLinkTab), _defineProperty(_availableTabs, InlineToolbarTab.RESET, ResetTab), _defineProperty(_availableTabs, InlineToolbarTab.HIGHLIGHT, HighlightTab), _availableTabs); // If the toolbar is closed, reset the link tool open state

  useEffect(function () {
    if (!isToolbarOpen) {
      setIsExternalLinkToolOpen(false);
    }
  }, [isToolbarOpen]);

  if (!isToolbarOpen || firstSelectedBlock.getType() === 'atomic') {
    return null;
  }

  return __jsx(ToolbarContainer, {
    ref: toolbarRef,
    "data-testid": "inline-toolbar"
  }, isExternalLinkToolOpen && __jsx(React.Fragment, null, __jsx(ExternalLinkInput, {
    onClickAway: function onClickAway() {
      return setKeepOpen(false);
    },
    onConfirm: function onConfirm(data) {
      setKeepOpen(false);
      addExternalLink(data);
    },
    focusOnMount: true
  }), __jsx(HorizontalSeparator, null)), __jsx(ButtonContainer, null, enabledBlocks.map(function (block) {
    var _Blocks$block;

    var InlineToolbarComponent = (_Blocks$block = Blocks[block]) === null || _Blocks$block === void 0 ? void 0 : _Blocks$block.inlineToolbarComponent;

    if (InlineToolbarComponent === undefined) {
      return;
    }

    return __jsx(InlineToolbarComponent, {
      editorState: editorState,
      setEditorState: setEditorState,
      key: block
    });
  }), currentBlock === null || currentBlock === void 0 ? void 0 : currentBlock.inlineToolbarTabs.map(function (tab, index) {
    var availableTab = availableTabs[tab]({
      editorState: editorState,
      currentEntityType: currentEntityType,
      firstSelectedBlock: firstSelectedBlock,
      handleInlineStyleToggle: handleInlineStyleToggle,
      handleInternalLinkToolToggle: handleInternalLinkToolToggle,
      handleExternalLinkToolToggle: handleExternalLinkToolToggle,
      handleAffiliationLinkToolToggle: handleAffiliationLinkToolToggle,
      handleResetStyleToggle: handleResetStyleToggle,
      handleHighlightToggle: handleHighlightToggle
    });
    return __jsx(Fragment, {
      key: tab
    }, index === 0 && __jsx(VerticalSeparator, null), availableTab);
  })));
};

export default InlineToolbar;